import { TermsOfService } from "@/components/common/TermsOfService";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/en/termsOfServiceLUX')({
  component: () => TermsOfService({ pdfPath: '/TOS_SGLUX_EN.pdf' }),
})